import { render, staticRenderFns } from "./ProductReviewsCreateReviewScoreInput.vue?vue&type=template&id=37fd9fde&scoped=true&"
import script from "./ProductReviewsCreateReviewScoreInput.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsCreateReviewScoreInput.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewsCreateReviewScoreInput.vue?vue&type=style&index=0&id=37fd9fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd9fde",
  null
  
)

export default component.exports